<template>
<v-layout row wrap w-100>
  <v-flex xs4 md4 centered>
    <v-flex xs12 pt-1 pl-1>
      <v-layout align-center justify-center row fill-height>
        <div>
          <img v-if="picture" :src="picture" aspect-ratio="1.7"/>
          <img v-else src="/img/img_not_found.png" aspect-ratio="1.7" contain/>
        </div>
      </v-layout>
    </v-flex>
  </v-flex>
  <v-flex xs8>
    <v-layout row wrap justify-end>
        <v-flex xs6 md4>
            <div class="caption grey--text">Serie</div>
            <div class=""><span class="orange--text" v-if="product.pair == 1">(P) </span>{{product.serial_number}}</div>
        </v-flex>
        <v-flex xs6 md4>
            <div class="caption grey--text">Marca</div>
            <div class="">{{product.maker_name}}</div>
        </v-flex>
        <v-flex xs6 md3 class="mt-2 mr-2 pr-3">
            <div right class="orange--text font-weight-black text-xs-right">{{product.pesos_price | currency }}</div>
        </v-flex>
    </v-layout>
    <v-layout row wrap>
        <v-flex xs3>
            <div class="caption grey--text text-xs-right">Precio</div>
            <div class="text-xs-right">{{product.price_ratio | currency('',0)}}</div>
            <div class="text-xs-right">{{product.max_price | currency }}</div>
            <div class="text-xs-right">{{product.min_price | currency}}</div>
        </v-flex>
        <v-flex xs4>
            <div class="caption grey--text text-xs-right">Peso</div>
            <div class="text-xs-right">{{product.weigth_ratio | currency('', 0)}}</div>
            <div class="text-xs-right">{{product.max_weigth | currency('', 0)}}</div>
            <div class="text-xs-right">{{product.min_weigth | currency('', 0)}}</div>
        </v-flex>

        <v-flex xs4
          class="ccontent text-center"
        >
          <div>
            <div class="caption grey--text">Muestras</div>
            <div right class="">{{product.samples | currency('',0) }}</div>
            
            <div class="caption grey--text"> 
              <v-btn 
                class="w-100" 
                type="submit" 
                color="primary"
                @click="goDetails(product)"
                >Editar catalizador</v-btn>
            </div>

            <div class="caption grey--text"> 
              <v-btn 
                class="w-100" 
                type="submit" 
                color="primary"
                @click="changeMaker(product)"
                >Cambiar marca</v-btn>
            </div>
          </div>
        </v-flex>
    </v-layout>

  </v-flex>
</v-layout>

</template>

<script>


import { cachiosInstance } from '../../axios';


export default {
  name: 'avg-product-row',
  props: ['product'],
  data() {
    return {
      picture: '',
    };
  },
  watch: {
    product() {
      if (this.product.picture_path) {
        this.retrieveImage();
      }else {
        this.picture = undefined;
      }
    }
  },
  methods: {
    async retrieveImage() {
      await cachiosInstance.get(`/img/${this.product.picture_path}`)
        .then( (result) => {
          this.picture = result.data;
        })
        .catch( (error) => {
          return response;
        });
    },
    goDetails(product){
      this.$emit('goDetails', product)
    },
    changeMaker(product){
      this.$emit('changeMaker', product)
    }
  },
  mounted() {
    if (this.product.picture_path) {
      this.retrieveImage();
    }else {
      this.picture = undefined;
    }
  },
};
</script>
<style scoped>
.ccontent {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>